// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"a1046617","91":"a1046617","605":"a1046617","687":"a1046617","2028":"a1046617","2529":"adff3739","3098":"40f68f47","5429":"620658d7","7335":"a1046617","8770":"a1046617"}[chunkId] + ".chunk.css";
};